<template>
  <el-dialog
    v-model="visible"
    width="500px"
    @close="onClose"
    :show-close="false"
    append-to-body
    destroy-on-close
    class="appointment-modal appointment-modal--edit">
    <div class="appointment-modal-body">
    <button class="modal-close-btn" @click="onClose">×</button>
    <div class="appointment-header-visual">
      <div class="header-row">
        <div class="header-item">
          <el-icon>
            <Calendar />
          </el-icon>
          <span>{{ formatDate(appointment.date) }}</span>
          <span style="color: var(--ui-color-text-soft);">
            ({{ formattedDate(appointment.date) }}
            <span
              class="date-weekday"
              :class="{ weekend: isWeekend }"
            >
            {{ weekdayLabel }}
          </span>)
          </span>
        </div>
        <div class="header-item">
          <el-icon>
            <Clock />
          </el-icon>
          <span>{{ appointment.start_time }} – {{ appointment.end_time }}</span>
        </div>
      </div>
      <div class="header-row">
        <div class="header-item">
          <el-icon>
            <UserFilled />
          </el-icon>
          <span>{{ appointment.user_name }}</span>
        </div>
        <div class="header-item">
          <el-icon>
            <Folder />
          </el-icon>
          <span>{{ appointment.room_name }}</span>
        </div>
      </div>
      <div class="header-row status-row">
        <div class="header-item">
          <el-icon>
            <AlarmClock />
          </el-icon>
          <span>{{ appointment.duration_time || totalDuration }} мин</span>
        </div>
      </div>
    </div>

    <div v-if="!clientIsDeleted" class="client-info-card">
      <div class="client-phone" v-if="appointment.client_phone">
        <el-icon>
          <Phone />
        </el-icon>
        <a :href="`tel:${appointment.client_phone}`" class="phone-link">{{ appointment.client_phone }}</a>
        <el-tooltip content="Скопировать" placement="top" popper-class="calendar-copy-tooltip">
          <el-button :icon="CopyDocument" text @click="copyPhone" class="copy-button" circle />
        </el-tooltip>
      </div>
      <div class="client-name" @click="showClientProfile" title="Показать профиль клиента">
        <el-icon>
          <UserFilled />
        </el-icon>
        <span class="name-text">{{ appointment.client_name }}</span>
        <el-button :icon="Edit" text circle @click.stop="showClientProfile" class="edit-button"
                   title="Редактировать клиента" />
      </div>
    </div>


    <el-form :model="form" label-width="110px" label-position="top" class="appointment-form">

      <!-- Услуги (мультивыбор) -->
      <el-form-item>
        <ServiceMultiSelect
          v-model="form.services"
          :services="services"
          :remote="true"
          :city-id="appointment?.city_id"
        />
      </el-form-item>

      <!-- Длительность -->
      <el-form-item label="Длительность">
        <div class="duration-control">
          <el-button class="duration-btn" @click="changeDuration(-15)">−</el-button>
          <div class="duration-value">
            <span class="duration-amount">{{ form.duration || 0 }}</span>
            <span class="duration-unit">мин.</span>
          </div>
          <el-button class="duration-btn" @click="changeDuration(15)">+</el-button>
        </div>
      </el-form-item>


      <!-- Комментарий -->
      <el-form-item label="Комментарий">
        <el-input
          type="textarea"
          v-model="form.comment"
          placeholder="Комментарий"
          :autosize="{ minRows: 1, maxRows: 4 }"
        />
      </el-form-item>
    </el-form>

      <div class="modal-footer-actions">
        <el-button @click="onClose" class="btn-cancel">Отмена</el-button>
        <el-button type="primary" @click="save" :disabled="!canSave" class="btn-save">Обновить</el-button>
      </div>
    </div>

  </el-dialog>
</template>
<script>
import {
  AlarmClock,
  Clock,
  Folder,
  UserFilled,
  Calendar,
  Files,
  Edit,
  Phone
} from '@element-plus/icons-vue'
import ServiceMultiSelect from '@/components/util/calendar/ServiceMultiSelect.vue'
import { mapState } from 'vuex'
import store from '@/components/store/store'

export default {
  name: 'AppointmentEditModal',
  components: { ServiceMultiSelect, Phone, AlarmClock, Folder, UserFilled, Clock, Calendar },
  props: {
    appointment: Object,
    date: { type: String, required: true }
  },
  data() {
    return {
      visible: true,
      form: {},
      edit: {
        name: this.appointment.client_name,
        phone: this.appointment.client_phone
      },
      initialized: false
    }
  },
  watch: {
    appointment: {
      handler(val) {
        this.initialized = false
        this.form = JSON.parse(JSON.stringify(val || {}))

        this.$nextTick(() => {
          if (this.form.duration_time) {
            this.form.duration = this.form.duration_time
          }
            // НЕ нужно else if (this.form.duration) — duration уже скопирован выше!
          // иначе считаем сумму по услугам
          else if (!this.form.duration) {
            this.form.duration = this.totalDuration
          }
          this.initialized = true
        })
      },
      immediate: true
    },
    'form.services': {
      handler() {
        // Пересчёт только после инициализации!
        if (this.initialized) {
          this.form.duration = this.totalDuration;
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState('services', ['services']),
    Edit() {
      return Edit
    },
    canSave() {
      return Array.isArray(this.form.services) && this.form.services.length > 0
        && (this.form.client_id || this.form.client_name)
    },
    CopyDocument() {
      return Files
    },
    clientIsDeleted() {
      // Если нет имени и нет телефона — считаем "удалён"
      const name = (this.appointment.client_name || '').trim()
      const phone = (this.appointment.client_phone || '').trim()
      // id может быть, но если имя и телефон пусты — это "удалён"
      return !name && !phone
    },
    weekdayLabel() {
      if (!this.date) return ''
      const d = new Date(this.date)
      if (isNaN(d.getTime())) return ''
      const weekdays = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ']
      return weekdays[d.getDay()]
    },
    isWeekend() {
      if (!this.date) return false
      const d = new Date(this.date)
      if (isNaN(d.getTime())) return false
      return d.getDay() === 0 || d.getDay() === 6
    },
    totalDuration() {
      if (this.form && this.form.services && this.form.services.length) {
        return this.form.services.reduce((sum, s) => sum + (s.duration || 0), 0)
      }
      return 0
    }
  },
  methods: {
    changeDuration(step) {
      const next = (this.form.duration || 0) + step
      this.form.duration = Math.max(0, next)
    },
    showClientProfile() {
      if (this.appointment.client_id) {
        this.$emit('show-client', this.appointment.client_id)
      }
    },
    copyPhone() {
      if (this.appointment.client_phone) {
        navigator.clipboard.writeText(this.appointment.client_phone).then(() => {
          this.$message.success('Скопировано')
        }).catch(() => {
          alert('Не удалось скопировать')
        })
      }
    },
    onClose(){
      this.$emit('close');
    },
    formattedDate(date) {
      const months = [
        'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня',
        'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'
      ]
      // YYYY-MM-DD
      const [, month, day] = date.split('-')
      const dayStr = day.length === 1 ? `0${day}` : day
      const monthName = months[parseInt(month, 10) - 1]
      return `${dayStr} ${monthName}`
    },
    formatDate(date) {
      if (!date) return ''
      // формат "2025-06-06" → "06.06.2025"
      const parts = date.split('-')
      if (parts.length !== 3) return date
      return `${parts[2]}.${parts[1]}.${parts[0]}`
    },
    save() {
      store.dispatch('appointments/updateAppointment', this.form);
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.appointment-header-visual {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.header-row {
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.header-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--ui-color-text-body);
  gap: 10px;
  line-height: 1.25;
}

.status-row {
  margin-top: 2px;
}

.client-info-card {
  border: none;
  border-radius: 5px;
  padding: 14px 16px;
  margin-bottom: 10px;
  background:
    linear-gradient(rgb(16 53 117 / 49%), rgb(16 53 117 / 49%)),
    linear-gradient(151deg, #15264e 0%, #030b1b 75%);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.client-phone {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--ui-color-text-regular);
}

.phone-link {
  color: #ffffff;
  text-decoration: none;
}

.copy-button {
  padding: 0;
  margin-left: 6px;
  color: #08255b;
  font-size: 22px;
}

:deep(.copy-button.el-button.is-text),
:deep(.copy-button.el-button.is-text:hover),
:deep(.copy-button.el-button.is-text:focus),
:deep(.copy-button.el-button.is-text:active) {
  color: #031230 !important;
}

:deep(.copy-button.el-button.is-text:hover),
:deep(.copy-button.el-button.is-text:focus),
:deep(.copy-button.el-button.is-text:active) {
  background: linear-gradient(rgb(16 53 117 / 52%), rgb(16 53 117 / 52%)) !important;
  box-shadow: 0 0 0 1px rgb(63 111 184 / 55%) inset;
}

:deep(.calendar-copy-tooltip.el-popper) {
  background: linear-gradient(rgb(16 53 117 / 88%), rgb(16 53 117 / 88%)) !important;
  border: 1px solid #3f6fb8 !important;
  color: #ffffff !important;
}

:deep(.calendar-copy-tooltip.el-popper .el-popper__arrow::before) {
  background: linear-gradient(rgb(16 53 117 / 88%), rgb(16 53 117 / 88%)) !important;
  border: 1px solid #3f6fb8 !important;
}

.client-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
}

.name-text {
  user-select: text;
}

.appointment-modal-body {
  background: linear-gradient(rgba(0, 108, 254, 0.22), rgba(0, 108, 254, 0.22)), linear-gradient(151deg, #15264e 0%, #030b1b 100%);
  border-radius: 8px;
  padding: 18px 20px 16px;
  position: relative;
}

.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

:global(.appointment-modal) {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  margin-top: 7vh !important;
}

:global(.appointment-modal .el-dialog__header) {
  background: transparent !important;
  padding: 0;
  margin: 0;
}

:global(.appointment-modal .el-dialog__body) {
  background: transparent !important;
  padding: 0;
}

:global(.appointment-modal .el-dialog__footer) {
  background: transparent !important;
  padding: 0;
  display: none;
}

:global(.appointment-modal .el-dialog__headerbtn .el-dialog__close) {
  color: #0c1f49;
  font-size: 24px;
}

.modal-close-btn {
  position: absolute;
  right: 14px;
  top: 10px;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #031230;
  font-size: 24px;
  line-height: 24px;
  cursor: pointer;
  z-index: 2;
}

.appointment-modal-body :deep(.el-icon),
.appointment-modal-body :deep(.el-icon svg),
.appointment-modal-body :deep(.el-icon svg path) {
  color: #031230 !important;
  fill: #031230 !important;
  stroke: #031230 !important;
}

.header-item,
.client-phone,
.client-name {
  color: #ffffff;
}

.header-item :deep(.el-icon),
.client-phone :deep(.el-icon),
.client-name :deep(.el-icon) {
  color: #031230 !important;
}

.header-item :deep(.el-icon svg),
.client-phone :deep(.el-icon svg),
.client-name :deep(.el-icon svg) {
  color: #031230 !important;
  fill: #031230 !important;
  stroke: #031230 !important;
}

.copy-button :deep(.el-icon),
.edit-button :deep(.el-icon) {
  color: #031230 !important;
}

.copy-button :deep(.el-icon svg),
.edit-button :deep(.el-icon svg) {
  color: #031230 !important;
  fill: #031230 !important;
  stroke: #031230 !important;
}

.appointment-form :deep(.el-form-item__label) {
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 8px;
}

.appointment-form :deep(.el-form-item) {
  margin-bottom: 14px;
}

.appointment-form :deep(.el-input__wrapper),
.appointment-form :deep(.el-textarea__inner),
.appointment-form :deep(.el-select__wrapper) {
  background: #0c224b !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  color: #00c3fe !important;
  min-height: 40px;
  border-radius: 5px;
}

.appointment-form :deep(.service-multiselect .el-input__wrapper) {
  background: #0c224b !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
}

.appointment-form :deep(.el-input__inner),
.appointment-form :deep(.el-textarea__inner) {
  color: #00c3fe !important;
  font-size: 16px;
}

.appointment-form :deep(.el-input__inner::placeholder),
.appointment-form :deep(.el-textarea__inner::placeholder) {
  color: rgba(0, 195, 254, 0.6) !important;
}

.duration-control {
  display: flex;
  align-items: center;
  gap: 4px;
}

.duration-btn {
  width: 34px;
  min-width: 34px;
  height: 34px;
  min-height: 34px;
  font-size: 24px;
  border-radius: 6px;
  border: none;
  background: var(--appointment-control-duration);
  color: var(--appointment-control-text);
  padding: 0;
  line-height: 1;
  box-shadow: none;
}

.duration-value {
  min-width: 80px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
  background: var(--appointment-value);
  color: var(--appointment-value-text);
  font-family: var(--appointment-font-display);
  border-radius: 6px;
  padding: 5px 10px;
  box-shadow: none;
}

.duration-amount {
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}

.duration-unit {
  font-size: 12px;
  line-height: 1;
  font-weight: 700;
  margin-top: 0;
  letter-spacing: 0.01em;
}

.btn-cancel,
.btn-save {
  min-width: 88px;
  height: 34px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 700;
  border: none;
}

.btn-cancel {
  background: var(--appointment-secondary);
  color: var(--appointment-secondary-text);
  box-shadow: 0 0 0 1px rgba(118, 159, 232, 0.25) inset;
}

.btn-save {
  background: var(--appointment-primary) !important;
  color: var(--appointment-primary-text) !important;
}

:global(.appointment-modal .el-button),
:global(.appointment-modal .el-link),
:global(.appointment-modal .el-input__wrapper),
:global(.appointment-modal .el-textarea__inner),
:global(.appointment-modal .el-select__wrapper),
:global(.appointment-modal .el-input-number .el-input__wrapper) {
  transition: background-color .18s ease, color .18s ease, border-color .18s ease, box-shadow .18s ease, filter .18s ease;
}

:global(.appointment-modal .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):hover),
:global(.appointment-modal .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):focus-visible),
:global(.appointment-modal .el-button.is-text:hover),
:global(.appointment-modal .el-button.is-text:focus-visible) {
  background: linear-gradient(rgb(16 53 117 / 52%), rgb(16 53 117 / 52%)) !important;
  border-color: #3f6fb8 !important;
  color: #ffffff !important;
  box-shadow: 0 0 0 1px rgb(63 111 184 / 55%) inset !important;
}

:global(.appointment-modal .el-button.el-button--primary:hover),
:global(.appointment-modal .el-button.el-button--primary:focus-visible) {
  filter: brightness(.95);
}

:global(.appointment-modal .el-button:active) {
  filter: brightness(.9);
}

:global(.appointment-modal .el-input__wrapper:hover),
:global(.appointment-modal .el-select__wrapper:hover),
:global(.appointment-modal .el-input-number .el-input__wrapper:hover),
:global(.appointment-modal .el-textarea__inner:hover),
:global(.appointment-modal .el-input__wrapper.is-focus),
:global(.appointment-modal .el-select__wrapper.is-focused),
:global(.appointment-modal .el-input-number .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #3f6fb8 inset !important;
  background: #0d2757 !important;
}

:global(.appointment-modal .el-link:hover),
:global(.appointment-modal .el-link:focus-visible) {
  color: #00c3fe !important;
}

:global(.appointment-modal .el-table__body tr:hover > td.el-table__cell) {
  background: rgba(24, 53, 104, 0.55) !important;
}

@media (max-width: 900px) {
  .appointment-modal-body {
    padding: 18px 16px 16px;
  }

  .header-item {
    font-size: 16px;
  }

  .appointment-form :deep(.el-form-item__label) {
    font-size: 16px;
  }

  .appointment-form :deep(.el-input__inner),
  .appointment-form :deep(.el-textarea__inner),
  .duration-value {
    font-size: 16px;
  }

  .client-phone {
    font-size: 18px;
  }

  .client-name {
    font-size: 20px;
  }

  .btn-cancel,
  .btn-save {
    min-width: 120px;
    height: 44px;
    font-size: 20px;
  }

  .duration-btn {
    width: 34px;
    min-width: 34px;
    height: 34px;
    min-height: 34px;
    font-size: 28px;
    border-radius: 6px;
  }

  .duration-value {
    min-width: 80px;
    height: 34px;
    border-radius: 6px;
  }

  .duration-amount {
    font-size: 16px;
  }

  .duration-unit {
    font-size: 12px;
  }
}

:global(.appointment-modal--edit .duration-control) {
  gap: 4px !important;
}

:global(.appointment-modal--edit .duration-btn.el-button) {
  width: 34px !important;
  min-width: 34px !important;
  height: 34px !important;
  min-height: 34px !important;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 6px !important;
  background: var(--appointment-control-duration) !important;
  color: var(--appointment-control-text) !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  box-shadow: none !important;
}

:global(.appointment-modal--edit .duration-btn.el-button:hover),
:global(.appointment-modal--edit .duration-btn.el-button:focus-visible),
:global(.appointment-modal--edit .duration-btn.el-button:active) {
  background: var(--appointment-control-duration) !important;
  color: var(--appointment-control-text) !important;
  border: 0 !important;
  box-shadow: none !important;
}

:global(.appointment-modal--edit .duration-value) {
  min-width: 80px !important;
  height: 34px !important;
  padding: 5px 10px !important;
  border-radius: 6px !important;
  background: var(--appointment-value) !important;
  color: var(--appointment-value-text) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  font-size: inherit !important;
  line-height: 1 !important;
}
</style>
